import { CreditSource } from "@/types/misc"
import { cn } from "cn"

import IconInfo from "@/components/icons/info"
import {
  Popover,
  PopoverContent,
  PopoverContentProps,
  PopoverTrigger,
} from "./ui/popover"

const UNSPLASH_UTM = "utm_source=mindtrip&utm_medium=referral"

interface CreditPopoverProps {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  className?: string
  credit?: CreditSource
  source?: CreditSource
  sourcePrefix?: string
  align: PopoverContentProps["align"]
  side: PopoverContentProps["side"]
}

export function CreditPopover({
  open,
  onOpenChange,
  className,
  align,
  side,
  credit,
  source,
  sourcePrefix,
}: CreditPopoverProps) {
  if (!credit?.name && !source?.name) return null
  const isUnplash = credit?.url?.includes("unsplash")
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger
        onClick={(e) => e.stopPropagation()}
        className={cn(
          "relative rounded-full bg-black-a-2 text-xl text-white-a-9 transition-colors hover:bg-black-a-9 hover:text-white-a-11 data-popup-open:bg-black-a-9 data-popup-open:text-white-a-11",
          className
        )}
      >
        <span className="absolute top-1/2 left-1/2 size-7 -translate-1/2" />
        <IconInfo />
        <span className="sr-only">Photo Credit</span>
      </PopoverTrigger>
      <PopoverContent align={align} side={side} className="flex p-0 text-xs">
        <span className="px-3 py-1.5">
          {credit?.name ? (
            <>
              Photo by{" "}
              {credit.url ? (
                <a
                  href={`${credit.url}${isUnplash ? `?${UNSPLASH_UTM}` : ""}`}
                  className="underline hover:text-muted"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {credit.name}
                </a>
              ) : (
                credit.name
              )}
            </>
          ) : null}
          {isUnplash && (
            <>
              {" on "}
              <a
                href={`https://unsplash.com/?${UNSPLASH_UTM}`}
                className="underline hover:text-muted"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                Unsplash
              </a>
            </>
          )}
          {credit?.name && source?.name ? <br /> : null}
          {source?.name ? (
            <>
              {`${sourcePrefix ? sourcePrefix + " sourced" : "Sourced"} from `}
              <a
                href={source.url}
                className="underline hover:text-muted"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                {source.name}
              </a>
            </>
          ) : null}
        </span>
      </PopoverContent>
    </Popover>
  )
}
